import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import {
  AutocompleteInput,
  CustomSelect,
  DateInput,
  EmailInput,
  IntInput,
  PasswordInput,
  CustomSwitch,
  TextInput,
} from "components/Input/Index.js";
import { compte } from "variables/patrimoine.js";
import { billData } from "variables/lists/imports";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { statusEnergy, typeAuthorization, authorizationStatus } from "variables/lists/authorization";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";

import { getAPIAuthorization, getFiles } from "services/ConfigServices";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "0px",
    marginBottom: "0px",
    marginTop: "15px",
    fontFamily: '"Source Sans Pro",sans-serif',
    width: "96%",
    marginLeft: "2%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "normal",
    fontWeight: "bold",
    height: "40px",
    fontSize: "0.75rem",
    padding: "5px 15px",
    marginRight: "0px",
    marginBottom: "0px",
    marginTop: "15px",
    fontFamily: '"Source Sans Pro",sans-serif',
    width: "96%",
    marginLeft: "2%",
  },
}));

function EditAuthorizationDialog(props) {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const currentusertype = localStorage.getItem('userType');
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const {
    setLoading,
    closeModal,
    refetch,
    setNotification,
    authorizationId,
    type,
    otherdata,
    energy,
    metersDso,
    legalname,
    datebegin,
    dateend,
    ged,
    verified,
    comment,
    firstname,
    lastname,
    email,
    postalcode,
    handleEnergyChange,
    handleDsoChange,
    handleLegalnameChange,
    handleDatebeginChange,
    handleDateendChange,
    handleAssociatedfilesChange,
    handleVerifiedChange,
    handleCommentChange,
    handleFirstnameChange,
    handleLastnameChange,
    handleEmailChange,
    handlePostalcodeChange,
    handleTypeChange,
    handleApiaccountmailChange,
    handleApisecretkeyChange,
    handleFtpdirectoryChange,
    handleDsochoruscodeChange,
    handleDsofiletemplateChange,
    handleGetAttachedFileChange
  } = props;

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (ged !== undefined) {
      gedCardId.push(ged);
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    let selected = {};
    if (getGedNames && getGedNames.length > 0)
      selected = getGedNames[0];
    return selected;
  };

  useEffect(() => {
    let error = false;
    if (!energy || (!metersDso && type !== 'dcx') || !legalname || !datebegin || !dateend
      || !firstname || !lastname || !email || !postalcode) {
      error = true;
    }
    setButtonDisabled(error);
  });

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleSubmit = (event) => {
    updateAuthorization(event);
    setLoading(true);
    closeModal();
  };

  const updateAuthorization = async (event) => {
    axios
      .put(
        getAPIAuthorization(authorizationId),
        {
          type,
          energy,
          dso: metersDso,
          legalname,
          datebegin,
          dateend,
          associatedfile: ged,
          verified,
          comment,
          firstname,
          lastname,
          email,
          postalcode,
          otherdata
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Autorisation modifiée");
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        setLoading(false);
      });
  };


  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <CustomSelect
                inputTitle={compte.authorization.type}
                selectValue={type}
                handleSelectValueChange={handleTypeChange}
                data={typeAuthorization}
                isRequired={true}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={compte.authorization.energy}
                selectValue={energy}
                handleSelectValueChange={handleEnergyChange}
                data={statusEnergy}
                isRequired={true}
              />
            </div>
            {currentusertype == 1 &&
              <div>
                <CustomSelect
                  inputTitle={compte.authorization.verified}
                  selectValue={verified}
                  handleSelectValueChange={handleVerifiedChange}
                  data={authorizationStatus}
                />
              </div>
            }
            {
              (type !== 'dcx') &&
              <div>
                <TextInput
                  inputTitle={compte.authorization.dso}
                  textInput={metersDso}
                  handleTextInputChange={handleDsoChange}
                  isRequired={true}
                />
              </div>
            }
            {
              (type === 'chorus') &&
              <>
                <div>
                  <IntInput
                    inputTitle={compte.authorization.dsochoruscode}
                    intInput={otherdata?.dsochoruscode}
                    handleIntInputChange={handleDsochoruscodeChange}
                    isRequired={true}
                  />
                </div>
                <div>
                  <CustomSelect
                    inputTitle={compte.authorization.dsofiletemplate}
                    selectValue={otherdata?.dsofiletemplate}
                    handleSelectValueChange={handleDsofiletemplateChange}
                    data={billData}
                    isRequired={true}
                  />
                </div>
              </>
            }
            {
              (type === 'engiebilleelectricity' || type === 'engiebillegas' || type === 'chorus') &&
              <>
                <div>
                  <TextInput
                    inputTitle={compte.authorization.apiaccountmail}
                    textInput={otherdata?.apiaccountmail}
                    handleTextInputChange={handleApiaccountmailChange}
                  />
                </div>
                <div>
                  <PasswordInput
                    inputTitle={compte.authorization.apisecretkey}
                    textInput={otherdata?.apisecretkey}
                    handleTextInputChange={handleApisecretkeyChange}
                  />
                </div>
              </>
            }
            {
              (type === 'engiebilleelectricity' || type === 'engiebillegas') &&
              <>
                <div>
                  <CustomSwitch
                    inputTitle={compte.authorization.getAttachedFile}
                    checkedState={otherdata?.getAttachedFile}
                    handleSwitchChange={handleGetAttachedFileChange}
                  />
                </div>
              </>
            }
            {
              (type === 'gdbftpgas') &&
              <>
                <div>
                  <TextInput
                    inputTitle={compte.authorization.ftpdirectory}
                    textInput={otherdata?.ftpdirectory}
                    handleTextInputChange={handleFtpdirectoryChange}
                  />
                </div>
              </>
            }
            <div>
              <TextInput
                inputTitle={compte.authorization.legalname}
                textInput={legalname}
                handleTextInputChange={handleLegalnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.authorization.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
                isRequired={true}
              />
            </div>
            <div>
              <DateInput
                inputTitle={compte.authorization.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
                isRequired={true}
              />
            </div>
            <div>
              <AutocompleteInput
                isMultiple={false}
                specialWidth={"97%"}
                inputTitle={compte.authorization.associatedfile}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>

            <div>
              <TextInput
                inputTitle={compte.authorization.firstname}
                textInput={firstname}
                handleTextInputChange={handleFirstnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.authorization.lastname}
                textInput={lastname}
                handleTextInputChange={handleLastnameChange}
                isRequired={true}
              />
            </div>
            <div>
              <EmailInput
                inputTitle={compte.authorization.email}
                emailInput={email}
                handleEmailInputChange={handleEmailChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={compte.authorization.postalcode}
                intInput={postalcode}
                handleIntInputChange={handlePostalcodeChange}
                isRequired={true}
              />
            </div>
            <div>
              <TextInput
                inputTitle={compte.authorization.comment}
                textInput={comment}
                handleTextInputChange={handleCommentChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default EditAuthorizationDialog;
